import {
  Avatar,
  Button,
  CircularProgress,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
  TextField,
  Typography,
  Link,
} from '@material-ui/core';
import {
  ExpandMore as ExpandMoreIcon,
  PauseCircleFilled as PauseCircleFilledIcon,
  PlayCircleFilledOutlined as PlayArrowFilledIcon,
  PlayCircleOutline as PlayArrowIcon,
} from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { DragSourceMonitor, useDrag } from 'react-dnd';
import { useAudio, useDebounce } from 'react-use';
import { useLocalStorage } from 'use-hooks';

import { Album, Artist, getAlbum, getDisco, getSearchArtists, getSimilarArtists, SimilarArtist, Track } from './ApiManager';
import { REACT_APP_SAMPLE_URL } from './env';

import 'promise-polyfill/src/polyfill'
import 'unfetch/polyfill'
import 'abortcontroller-polyfill'

// import { debounce } from 'lodash'
// import { SimilarArtist } from './ApiManager';
// const { useDrag } = dnd
const useStyles = makeStyles({
  artistAvatar: {
    display: 'flex',
    alignItems: 'center',
  },
  albumCard: {
    display: 'flex',
    flexFlow: 'row',
  },
  albumCover: {
    width: 64,
  }
})

console.log('AbortController :)')
let abort = new AbortController()
// let queryPending = false

function artistPic(id: number) {
  return `https://covers3.hosting-media.net/art/r288/${id}.jpg`
}


function ArtistAvatar({ artist, albumCount, albumLength, onClickMore, setSearchText }:
{
  artist: Artist,
  albumCount?: number,
  albumLength?: number,
  onClickMore?: ()=>void,
  setSearchText?: (query: string)=>void,
}) {
  const [anchorEl, setAnchorEl] = useState(null as HTMLElement | null)
  const [isLoading, setIsLoading] = useState(false)
  const [similars, setSimilars] = useState([] as SimilarArtist[])
  const styles = useStyles()

  const finishedLoading = !(albumCount && albumLength && (albumCount > albumLength))

  const onClickSimilar = async (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
    const similars = await getSimilarArtists(artist.id)
    setSimilars(similars && similars.results && similars.results['related-artists'] || [])
  }
  
  const handleCloseSimilar = async () => {
    setAnchorEl(null)
    setSimilars([])
  }

  const onClickSimilarArt = (artistName: string) => {
    setAnchorEl(null)
    setSimilars([])
    if (setSearchText)
      setSearchText(artistName)
  }

  const onClickArt = (artistName: string) => {
    setAnchorEl(null)
    if (setSearchText)
      setSearchText(artistName)
  }

  return <Grid item xs={12} className={styles.artistAvatar} style={{ marginTop: 16 }}>
    <Avatar src={artistPic(artist.id)} style={{ marginRight: 16, flexShrink: 0 }} />
    <Typography variant='h6'
      noWrap={true}
      align='left'
      style={{ flexGrow: 1 }}>
        <Link color="inherit" href="#" onClick={() => onClickArt(artist.name)}>
        {artist.name}
        </Link>
    </Typography>
    
    {
      albumCount
      ? <Button style={{ flexShrink: 0, marginLeft: 16 }}
        variant='contained'
        color='secondary'
        disabled={similars.length > 0 || !!anchorEl}
        onClick={onClickSimilar}>
          Artistes similaires
      </Button>
      : null
    }

    {
      !finishedLoading
      ?  <Button style={{ flexShrink: 0, marginLeft: 16 }}
          variant='contained'
          disabled={isLoading && !finishedLoading}
          onClick={() => {
            if (isLoading)
              return
            setIsLoading(true)
            if (onClickMore)
              onClickMore()
          }}>
            {
              (isLoading && !finishedLoading)
              ? 'Chargement des albums...'
              : `Voir les ${albumCount} albums`
            }
        </Button>
      : null
    }

    <Menu
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleCloseSimilar}
      hidden={similars.length === 0}
    >
      {similars.map(art => <MenuItem key={art.id} onClick={() => onClickSimilarArt(art.name)}>
        <ListItemAvatar>
          <Avatar alt={art.name} src={artistPic(art.id)} />
        </ListItemAvatar>
        <Typography>
          {art.name}
        </Typography>
      </MenuItem>)}
    </Menu>
  </Grid>
}

const useAlbumStyle = makeStyles({
  root: {
    backgroundRepeat: 'no-repeat',
    backgroundSize: '74px 74px',
    backgroundPosition: 'left top',
    paddingLeft: '82px',
    backgroundImage: (props: any) => 'url(' + props.cover + ')',
  },
  content: {
    overflow: 'hidden'
  }
})
function AlbumCard({ album, signal, onClickTrack, onClick, playingTrack }: {
  album: Album,
  signal: AbortSignal,
  playingTrack: string | null,
  onClick: () => void,
  onClickTrack: (track: string) => void,
}) {

  const [tracks, setTracks] = useState(null as Track[] | null)
  const [expanded, setExpanded] = useState(false)
  // const styles = useStyles()

  useEffect(() => {
    if (!expanded)
      return
    getAlbum(album.barcode, signal).then(res => {
      const albumTracks = res.results ? res.results.tracks : []
      setTracks(albumTracks)
    }).catch(err => console.error(err))
  }, [expanded, album.barcode, signal])

  const style = useAlbumStyle({ cover: album.cover_url })
  return <Grid item xs={12} sm={6} md={6} lg={6}>
  <ExpansionPanel
    style={{ margin: 0 }}
    expanded={expanded}
    onChange={() => {
      setExpanded(!expanded)
      onClick()
    }}>
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} classes={{ root: style.root, content: style.content }}>
        <Typography variant='subtitle1' noWrap={true} style={{ textOverflow: 'ellipsis' }} display='block' align='left'>
          {album.name}
          <Typography variant='caption' align='left' display='block'>
            {album.ntracks} piste{album.ntracks === 1 ? '' : 's'}
          </Typography>
        </Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails style={{
        flexFlow: 'column',
        alignItems: 'flex-start',
        overflow: 'hidden',
      }}>
        {
          tracks
            ? (<List dense={true} style={{ width: '100%' }}>
              {
                tracks.map(track => playingTrack === track.barcode
                  ? <PlayingAlbumTrack
                      key={track.barcode}
                      track={track}
                      onClickTrack={onClickTrack}
                    />
                  : <TrackItem
                      key={track.barcode}
                      track={track}
                      onClickTrack={onClickTrack}
                      isPlaying={false}
                    />)
              }
            </List>)
            : <Typography variant='body2'>
                Chargement des pistes...
              </Typography>
        }
      </ExpansionPanelDetails>
    </ExpansionPanel>
    {/* <Menu
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleClose}
    >

    </Menu> */}
  </Grid>
}

function formatDuration(duration: number) {
  const seconds = duration % 60
  const minutes = Math.floor(duration / 60)
  if (seconds < 10)
    return `${minutes}:0${seconds}`
  return `${minutes}:${seconds}`
}

const urlStreaming = REACT_APP_SAMPLE_URL + '/partners/30000189/sample/'
const ext = '.m4a'
function PlayingAlbumTrack({ track, onClickTrack }: {
  track: Track,
  onClickTrack: (track: string) => void,
}) {
  const url = urlStreaming + track.barcode + ext
  const [audio, state, controls] = useAudio({
    src: url,
    autoPlay: true,
  })

  const { isPlaying } = state

  useEffect(() => {
    if (!isPlaying) {
      return
    }
    const player = document.getElementsByTagName('mme-player') as HTMLCollectionOf<MMEEmbeddedPlayer>
    if (player.length >= 1) {
      player[0].pause()
    }
  }, [isPlaying])

  return <div>
    {audio}

    <TrackItem
      track={track}
      onClickTrack={() => {
        if (state.isPlaying) {
          controls.pause()
        } else {
          controls.play()
          onClickTrack(track.barcode)
        }
      }}
      isPlaying={state.isPlaying} />
  </div>
}




function TrackItem({ track, onClickTrack, isPlaying } : {
  track: Track,
  isPlaying: boolean,
  onClickTrack: (track: string) => void,
}) {
  const [collectedProps, ref] = useDrag({
    item: { barcode: track.barcode, track: track, type: 'album-track' },
    collect: (monitor: DragSourceMonitor) => {
      return {
        dragging: monitor.isDragging(),
      }
    }
  })
  const { dragging } = collectedProps

  const [hover, setHover] = useState(false)
  const onMouseEnter = () => setHover(true)
  const onMouseLeave = () => setHover(false)

  return <ListItem
    onClick={() => onClickTrack(track.barcode)}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    ContainerProps={{
      ref: ref,
  } as unknown as any} style={{
    width: '100%',
    cursor: 'pointer',
    paddingLeft: 0,
    backgroundColor: dragging ? 'lightgrey' : 'transparent',
  }}>
    <ListItemIcon>
      {
        isPlaying
        ? <PauseCircleFilledIcon />
        : (hover
          ? <PlayArrowFilledIcon />
          : <PlayArrowIcon />)
      }
    </ListItemIcon>
    <ListItemText primary={track.title} />
    <ListItemSecondaryAction>
      <Typography
        variant='caption'
        align='left'
        style={{ flexGrow: 0, flexShrink: 0, paddingLeft: 16 }}>
        {formatDuration(track.duration)}
      </Typography>
    </ListItemSecondaryAction>
  </ListItem>
}

interface Discography {
  artist: Artist
  albums: Album[]
  albumCount: number | undefined
}

function SearchPanel() {
  
  const [query, setQuery] = useState('')
  const [history, setHistory] = useLocalStorage('search-history', [] as Discography[])
  const [artists, setArtists] = useState(history.map(h => h.artist))
  const [discos, setDiscos] = useState(history)
  const [queryPending, setQueryPending] = useLocalStorage('search-query-pending', false)

  const [playingTrack, setPlayingTrack] = useState(null as string | null)

  function onClickTrack(track: string) {
    setPlayingTrack(track)
  }

  async function loadMoreAlbums(artistId: number) {
    const res = await getDisco(artistId, {
      count: 50,
    })
    const disco = discos.filter(d => d.artist.id === artistId)[0]
    const di = { ...disco, albums: (res.results || { albums: [] }).albums }
    const index = discos.indexOf(disco)
    const newDiscos = [
      ...discos.slice(0, index),
      di,
      ...discos.slice(index + 1),
    ]
    setDiscos(newDiscos)
  }

  const pushArtistHistory = (disco: Discography) => {
    const newHistory = history.filter(h => h.artist.id !== disco.artist.id)
    setHistory([
      disco,
      ...newHistory.slice(0,6)
    ])
  }

  const typeQuery = async (evt: ChangeEvent<HTMLInputElement>) => {
    console.log('TYPE_QUERY', evt.target.value)
    const queryValue = evt.target.value
    await setSearchText(queryValue)
  }
  const setSearchText = async (queryValue: string) => {
    console.log('SET_SEARCH_TEXT', queryValue)
    setQuery(queryValue)
  }

  async function searchText(queryValue: string) {
    console.log('SEARCH_TEXT', queryValue)
    if (queryPending && !abort.signal.aborted) {
      abort.abort()
    }
    if (queryValue === '') {
      // don't send request if empty query
      if (abort) {
        abort.abort()
        console.log('AbortController x)')
        abort = new AbortController()
      }
      setArtists(history.map(h => h.artist))
      setDiscos(history)
      // setTracks([])
      // queryPending = false
      return
    }
    setQueryPending(true)
    // queryPending = true
    // console.log('queryPending=true', queryPending)
    const queryAbort = new AbortController()
    abort = queryAbort
    // console.log('abort', abort)
    try {
      const response = await getSearchArtists(queryValue, queryAbort.signal)
        .then(response => {
          return response
        })
      if (queryAbort.signal.aborted || queryAbort !== abort) {
        // queryPending = false
        // console.log('queryPending1', queryPending)
        return
      }
      if (response.results) {
        setArtists(response.results.artists)
        //const ids = response.results.artists.map(art => art.id)
        const ids:Array<number> = []
        let artAlbums:{[key:number]:Album[]} = {}
        response.results.artists.forEach(art => {
          if(art.id) {
            if(art.albums && art.albums.length > 0){
              artAlbums = artAlbums || {}
              artAlbums[art.id] = art.albums
            }
            else
              ids.push(art.id)
          }
        })
        if(Object.keys(artAlbums).length > 0){
          // albums already populated in artists response
          const discogs: Discography[] = []
          for(let id in artAlbums){
            discogs.push({
              artist: response.results!.artists.find(art => art.id === parseInt(id))!,
              albumCount: artAlbums[id].length,
              albums: artAlbums[id]
            })
          }
          setDiscos(discogs)
        }
        else {
          // albums not populated - fetch them
          const discography = await Promise.all(
            ids.map(id => getDisco(id, {
              signal: queryAbort.signal,
              count: (response.results && response.results.artists.length === 1)
                ? 100
                : 4
            }))
          )
          if (queryAbort.signal.aborted || queryAbort !== abort) {
            // queryPending = false
            // console.log('queryPending2', queryPending)
            return
          }
          setDiscos(discography.map(disco => ({
            artist: response.results!.artists.find(art => art.id === disco.item.id)!,
            albumCount: (disco.meta.albums || [{ total: 0 }])[0].total as number,
            albums: (disco.results || { albums: [] }).albums,
          })).filter(disco => disco.albums.length > 0))
        }
      } else if (artists.length === 0 && query !== '' && !queryPending) {
        // todo : afficher Aucun résultat pour la requete ${query}
        setArtists([])
        setDiscos([])
      } else {
        setArtists([])
        setDiscos([])
        // setTracks([])
      }
      // console.log('artists', artists)
      // console.log('query', query)
      // console.log('queryPending', queryPending)
      // console.log('artists === [] && query !== \'\' && !queryPending', artists === [] && query !== '' && !queryPending)

    } catch (error) {
      if (error && error.name === 'AbortError') {
        // Do Nothing
        return
      }
      throw error
    } finally {
      // queryPending = false
      if (abort === queryAbort) {
        setQueryPending(false)
      }
      // console.log('queryPending=false', queryPending)
    }
  }

  useDebounce(() => {
    searchText(query)
  }, 150, [query])

  return <div>
    <div style={{ position: 'relative', top: 0 }}>
      <TextField
        id='outlined-search'
        label="Rechercher un artiste ou un EAN d'album"
        type='search'
        margin='normal'
        variant='outlined'
        value={query}
        onChange={typeQuery}
        style={{ width: '100%', marginTop: 0 }}
      />
      {
        queryPending
          ? <CircularProgress size={16} style={{
            position: 'absolute',
            right: 13,
            top: 'calc(50% - 12px)'
          }} />
          : null
      }
    </div>
    <Grid container spacing={2} style={{ width: '100%', opacity: queryPending ? 0.5 : 1 }}>
    {
      query === '' && history.length === 0
        ? <Typography variant='body1' align='left' style={{ margin: 16 }}>
            Entrez le nom d'un artiste ou d'un groupe pour voir apparaitre sa discographie,
            composez ensuite votre playlist par simple glissé-déposé vers la playlist sélectionnée sur la droite.
          </Typography>
        : null
    }
    {
      artists.length === 0 && query !== '' && !queryPending
        ? <Typography variant='body1' align='left' style={{ margin: 16 }}>
            Aucun résultat trouvé pour <em>{query}</em>
          </Typography>
        : null
    }
    {
      discos.length > 0
      ? discos.map(disco => ([
        <ArtistAvatar
          key={disco.artist.id}
          artist={disco.artist}
          albumCount={disco.albumCount}
          albumLength={disco.albums.length}
          onClickMore={() => {
            loadMoreAlbums(disco.artist.id)
            pushArtistHistory(disco)
          }}
          setSearchText={setSearchText}
          />,
        ...disco.albums.map(alb =>
          <AlbumCard
            key={alb.barcode}
            album={alb}
            signal={abort.signal}
            onClick={() => pushArtistHistory(disco)}
            onClickTrack={onClickTrack}
            playingTrack={playingTrack} />)
      ]))
      : artists.map(art => <ArtistAvatar
          key={art.id}
          artist={art}
        />)
    }
    </Grid>
  </div>
}

export default SearchPanel